{
  "Admin": "管理者",
  "Editor": "編集者",
  "Moderator": "モデレーター",
  "Account holder": "アカウント所有者",
  "Everything you can do, including inviting people, except buying credits or plans and deleting the account.": "メンバーの招待を含め、あなたができることはすべて行えます。ただし、クレジットやプランの購入とアカウントの削除はできません。",
  "Creates and runs events: details, going live, guests and video. Can't delete, unlock or sell tickets.": "イベントを作成・運営します（詳細、ライブ配信、ゲスト、動画）。削除、アンロック、チケットの販売はできません。",
  "Looks after guestbooks and chats. Sees the events and their links, nothing else.": "ゲストブックとチャットを管理します。閲覧できるのはイベントとそのリンクだけです。",
  "Everything you can do with this event, including deleting it and inviting people to it.": "イベントの削除やメンバーの招待を含め、このイベントであなたができることはすべて行えます。",
  "Runs this event: details, going live, guests and video. Can't delete it, unlock it or sell tickets.": "このイベントを運営します（詳細、ライブ配信、ゲスト、動画）。イベントの削除、アンロック、チケットの販売はできません。",
  "Looks after this event's guestbook or chat. Sees the event and its link, nothing else.": "このイベントのゲストブックやチャットを管理します。閲覧できるのはイベントとそのリンクだけです。",
  "You can do everything the account holder can, except buy credits or plans and delete the account.": "アカウント所有者ができることはすべて行えます。ただし、クレジットやプランの購入とアカウントの削除はできません。",
  "You can create and run events: details, going live, guests and video.": "イベントの作成と運営（詳細、ライブ配信、ゲスト、動画）を行えます。",
  "You can look after the events' guestbooks and chats.": "イベントのゲストブックとチャットを管理できます。",
  "You can do everything with this event, including inviting others to it.": "ほかの人の招待を含め、このイベントのすべての操作を行えます。",
  "You can run this event: details, going live, guests and video.": "このイベントの運営（詳細、ライブ配信、ゲスト、動画）を行えます。",
  "You can look after this event's guestbook or chat.": "このイベントのゲストブックやチャットを管理できます。",
  "Something went wrong. Try again.": "問題が発生しました。もう一度お試しください。",
  "You don't have access to that in this account.": "このアカウントでは、その操作を行う権限がありません。",
  "Teams isn't available yet.": "チーム機能はまだご利用いただけません。",
  "Couldn't reach EventLive. Check your connection and try again.": "EventLiveに接続できませんでした。接続を確認して、もう一度お試しください。",
  "Sign in first.": "先にログインしてください。",
  "You don't have access to {team}'s account any more.": "{team}のアカウントにはアクセスできなくなりました。",
  "Couldn't open {team}'s account. Try again.": "{team}のアカウントを開けませんでした。もう一度お試しください。",
  "Teams isn't switched on for {team}'s account yet.": "{team}のアカウントでは、チーム機能がまだオンになっていません。",
  "Couldn't switch accounts": "アカウントを切り替えられませんでした",
  "Accounts": "アカウント",
  "My account": "自分のアカウント",
  "Your own events, plan and purchases": "自分のイベント、プラン、購入内容",
  "Use my own account": "自分のアカウントを使う",
  "Work in {team}'s account": "{team}のアカウントで作業",
  "Leave {team}'s account": "{team}のアカウントから退出",
  "Leave {team}'s account?": "{team}のアカウントから退出しますか？",
  "Stop working on {team}'s event?": {
    "other": "{team}のイベントでの作業をやめますか？"
  },
  "You'd need a new invite to get access again.": "再びアクセスするには、新しい招待が必要になります。",
  "You left {team}'s account.": "{team}のアカウントから退出しました。",
  "Couldn't leave": "退出できませんでした",
  "Shared with you": "あなたと共有",
  "All events": "すべてのイベント",
  "Open {team}'s account": "{team}のアカウントを開く",
  "Open {team}'s event": "{team}のイベントを開く",
  "Working in {team}": "{team}で作業中",
  "You're working in {team}'s account": "{team}のアカウントで作業しています",
  "Back in your own account": "自分のアカウントに戻りました",
  "Not available": "利用できません",
  "Back to events": "イベント一覧に戻る",
  "Your role in {team}'s account doesn't include this. Ask an admin of the account if you need it.": "{team}のアカウントでのあなたの役割には、この権限が含まれていません。必要な場合は、アカウントの管理者に依頼してください。",
  "Your role in this account doesn't include this. Ask an admin of the account if you need it.": "このアカウントでのあなたの役割には、この権限が含まれていません。必要な場合は、アカウントの管理者に依頼してください。",
  "Teams is part of business accounts: invite people to work in your account with their own sign-in. To use it, choose Business as your account type in Profile › Update Profile.": "チーム機能はビジネスアカウントでご利用いただけます。メンバーを招待すると、それぞれ自分のアカウントでログインして、あなたのアカウントで作業できます。ご利用になるには、「プロフィール」›「プロフィールを更新」で、アカウントの種類として「ビジネス」を選んでください。",
  "{team}'s team": "{team}のチーム",
  "Only admins of {team}'s account can see its team. Switch to your own account to manage yours.": "このチームを表示できるのは、{team}のアカウントの管理者だけです。自分のチームを管理するには、自分のアカウントに切り替えてください。",
  "People who work in this account with their own sign-in.": "このアカウントで作業するメンバーです。各メンバーは自分のアカウントでログインします。",
  "People who work in your account with their own sign-in. You keep your plan, your purchases and your account.": "あなたのアカウントで作業するメンバーです。各メンバーは自分のアカウントでログインします。プラン、購入内容、アカウントは引き続きあなたのものです。",
  "People who can work on “{title}” with their own sign-in.": "「{title}」で作業できるメンバーです。各メンバーは自分のアカウントでログインします。",
  "People who can work on this event with their own sign-in.": "このイベントで作業できるメンバーです。各メンバーは自分のアカウントでログインします。",
  "People you invite here can work on every {noun} of this event.": "ここで招待したメンバーは、このイベントのすべての{noun}で作業できます。",
  "Only admins can see and invite the people on this event.": "このイベントのメンバーを表示・招待できるのは、管理者だけです。",
  "Invite someone": "メンバーを招待",
  "Invite someone to this event": "このイベントにメンバーを招待",
  "They get an email with a link that works for 14 days, and accept with their own sign-in.": "招待された人には14日間有効なリンクがメールで届き、自分のアカウントでログインして承諾します。",
  "Email address": "メールアドレス",
  "e.g. sam@example.com": "例：yamada@example.com",
  "Enter a valid email address.": "有効なメールアドレスを入力してください。",
  "Role": "役割",
  "Send invite": "招待を送信",
  "Invite sent": "招待を送信しました",
  "We emailed {email} a link to join.": "{email}に参加用のリンクをメールで送りました。",
  "Couldn't send the invite. Try again.": "招待を送信できませんでした。もう一度お試しください。",
  "Invite not sent": "招待は送信されませんでした",
  "Couldn't load the people. Try again.": "メンバーを読み込めませんでした。もう一度お試しください。",
  "People on this event": "このイベントのメンバー",
  "{count} person": {
    "other": "{count}人"
  },
  "No one yet.": "まだ誰もいません。",
  "No one yet. Invite someone above.": "まだ誰もいません。上のフォームから招待してください。",
  "Invites": "招待中",
  "{count} waiting to be accepted": {
    "other": "承諾待ち{count}件"
  },
  "Account team": "アカウントのチーム",
  "They can work on every event in the account, this one included.": "このイベントを含め、アカウントのすべてのイベントで作業できます。",
  "Manage the team": "チームを管理",
  "Someone": "誰か",
  "{name} (you)": "{name}（あなた）",
  "Invited": "招待済み",
  "Invite expires {date}": "招待の有効期限：{date}",
  "Joined {date}": "{date}に参加",
  "Send the invite to {name} again": "{name}に招待を再送信",
  "Invite sent again": "招待を再送信しました",
  "Change {name}'s role": "{name}の役割を変更",
  "Change role": "役割を変更",
  "Save role": "役割を保存",
  "Role changed": "役割を変更しました",
  "{name} is now {role}.": "{name}の役割を{role}に変更しました。",
  "Role not changed": "役割を変更できませんでした",
  "That didn't work": "うまくいきませんでした",
  "Withdraw the invite to {name}": "{name}への招待を取り消す",
  "Withdraw invite": "招待を取り消す",
  "Withdraw the invite to {name}?": "{name}への招待を取り消しますか？",
  "Withdraw the invite to them?": "この招待を取り消しますか？",
  "The link in their email stops working.": "招待メールのリンクは使えなくなります。",
  "Invite withdrawn": "招待を取り消しました",
  "team member|Remove {name}": "{name}を削除",
  "Remove {name}?": "{name}を削除しますか？",
  "Remove them?": "このメンバーを削除しますか？",
  "They lose access to this event right away.": "このイベントにはすぐにアクセスできなくなります。",
  "They lose access to the account right away.": "アカウントにはすぐにアクセスできなくなります。",
  "Stream keys": "ストリームキー",
  "Change the stream keys too": "ストリームキーも変更する",
  "Recommended. This event and its rooms get new keys if they haven't streamed yet. Update any encoder, OBS or camera link with the new key from How to Go Live.": "おすすめの設定です。まだ配信していない場合は、このイベントとそのルームに新しいキーが発行されます。エンコーダー、OBS、カメラのリンクは、「ライブ配信の方法」に表示される新しいキーで更新してください。",
  "Recommended. Upcoming events that haven't streamed yet get new keys. Update any encoder, OBS or camera link with the new key from How to Go Live.": "おすすめの設定です。まだ配信していない今後のイベントに、新しいキーが発行されます。エンコーダー、OBS、カメラのリンクは、「ライブ配信の方法」に表示される新しいキーで更新してください。",
  "Keep the stream keys": "ストリームキーはそのまま",
  "Encoders set up with the current keys keep working, and so would anyone who copied one.": "現在のキーで設定したエンコーダーは、そのまま使えます。ただし、キーをコピーした人も、そのキーで配信できてしまいます。",
  "team member|Removed": "メンバーを削除しました",
  "Removed. Upcoming events have new stream keys.": "メンバーを削除しました。今後のイベントのストリームキーは新しくなりました。",
  "You're invited": "招待されました",
  "Join with your own sign-in. Your own account and events stay yours.": "自分のアカウントでログインして参加してください。あなたのアカウントとイベントは、これまでどおりあなたのものです。",
  "{inviter} invited you to help with {target}.": "{inviter}が、{target}の作業にあなたを招待しました。",
  "their account": "相手のアカウント",
  "Sent to {email}": "送信先：{email}",
  "This invite is for the YouthStream app. Open the link on your iPhone, or sign in to YouthStream with the email it was sent to.": "この招待はYouthStreamアプリ用です。iPhoneでリンクを開くか、招待が届いたメールアドレスでYouthStreamにログインしてください。",
  "Sign in to accept": "ログインして承諾",
  "New to EventLive? Continue with your email to create a free account, then accept.": "EventLiveを初めてご利用ですか？メールアドレスで続けて無料アカウントを作成してから、招待を承諾してください。",
  "Accept as {email}": "{email}として承諾",
  "Accept invite": "招待を承諾",
  "Use another account": "別のアカウントを使う",
  "Go to my events": "マイイベントへ移動",
  "This invite link isn't valid. Ask for a new one.": "この招待リンクは無効です。新しいリンクを依頼してください。",
  "This invite has expired. Ask for a new one.": "この招待は有効期限が切れています。新しい招待を依頼してください。",
  "This invite was already used.": "この招待はすでに使用されています。",
  "This invite was withdrawn. Ask for a new one if you still need access.": "この招待は取り消されました。引き続きアクセスが必要な場合は、新しい招待を依頼してください。",
  "Couldn't open this invite. Try again.": "この招待を開けませんでした。もう一度お試しください。",
  "Couldn't accept the invite. Try again.": "招待を承諾できませんでした。もう一度お試しください。",
  "You can now work on {title}": "「{title}」で作業できるようになりました",
  "You can now work on the event": "イベントで作業できるようになりました",
  "You joined {team}'s account": "{team}のアカウントに参加しました",
  "account|Leave": "退出"
}
